import { Helmet } from "react-helmet";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import NavigationButtons from '@/components/NavigationButtons';

const DeepseekStock = () => {
  return (
    <>
      <Helmet>
        <title>DeepSeek AI Stock - Investment Information & Market Analysis</title>
        <meta 
          name="description" 
          content="Explore DeepSeek AI's stock information, market analysis, and investment opportunities. Stay updated with our latest financial data and market performance." 
        />
      </Helmet>

      <div className="min-h-screen pt-24 pb-12 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-white to-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h1 className="text-4xl font-bold text-gray-900 sm:text-5xl md:text-6xl">
              <span className="block">DeepSeek AI Stock</span>
              <span className="block text-[#0066FF] mt-2">Market Intelligence</span>
            </h1>
            <p className="mt-4 text-xl text-gray-500">
              Access comprehensive market data and investment insights
            </p>

            <NavigationButtons />
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
            <Card className="p-6">
              <CardHeader>
                <CardTitle>Investment Highlights</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="space-y-2">
                  <h3 className="font-semibold text-lg">Market Leadership</h3>
                  <p className="text-gray-600">
                    DeepSeek AI continues to lead in AI innovation, capturing significant market share in the rapidly growing AI sector.
                  </p>
                </div>
                <div className="space-y-2">
                  <h3 className="font-semibold text-lg">Strong Growth</h3>
                  <p className="text-gray-600">
                    Consistent revenue growth driven by expanding enterprise adoption and new product launches.
                  </p>
                </div>
                <div className="space-y-2">
                  <h3 className="font-semibold text-lg">Innovation Pipeline</h3>
                  <p className="text-gray-600">
                    Robust R&D investments maintaining competitive edge in AI technology development.
                  </p>
                </div>
              </CardContent>
            </Card>

            <Card className="p-6">
              <CardHeader>
                <CardTitle>Market Analysis</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="space-y-2">
                  <h3 className="font-semibold text-lg">Industry Trends</h3>
                  <p className="text-gray-600">
                    The AI industry continues to experience exponential growth, with DeepSeek AI well-positioned to capitalize on emerging opportunities.
                  </p>
                </div>
                <div className="space-y-2">
                  <h3 className="font-semibold text-lg">Competitive Position</h3>
                  <p className="text-gray-600">
                    Strong competitive moat built through proprietary technology and strategic partnerships.
                  </p>
                </div>
                <div className="space-y-2">
                  <h3 className="font-semibold text-lg">Future Outlook</h3>
                  <p className="text-gray-600">
                    Positive growth trajectory expected to continue with expansion into new markets and technologies.
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeepseekStock;
